const firmas = {

    BuscarFirmantes: 'SIVAC/Consultas/Firmas/BuscarFirmantes',
    BuscarFirmantesDadosDeBaja: 'SIVAC/Consultas/Firmas/BuscarFirmantesDadosDeBaja'
    
}

const consultas = {
    
    firmas: firmas
}

export default consultas;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Consultas/consultas.js
// module id = null
// module chunks = 